import { action } from 'typesafe-actions';
import { SolicitacoesRetornoItensNotaTypes, IItensNota, Pagination } from './types';

export const loadRequest = (nuNota: number, pagination?: Pagination) =>
  action(SolicitacoesRetornoItensNotaTypes.ITENS_NOTA_REQUEST, { nuNota, pagination });

export const loadSuccess = (data: IItensNota, pagination: Pagination) =>
  action(SolicitacoesRetornoItensNotaTypes.ITENS_NOTA_SUCCESS, { data, pagination });

export const loadFailure = () => action(SolicitacoesRetornoItensNotaTypes.ITENS_NOTA_FAILURE);
